import React from 'react';
import { DateInput, formatDateTime, formatRelative, toIsoString } from '../../utils/dates';

interface RelativeTimeProps {
  value?: DateInput;
  /** Shown when the value is missing or not a date. */
  fallback?: string;
  className?: string;
  /** Time zone for the exact date shown on hover (default: the browser's). */
  timeZone?: string;
}

/** "5 min ago", with the exact date and time on hover. */
const RelativeTime: React.FC<RelativeTimeProps> = ({ value, fallback = '-', className, timeZone }) => {
  const iso = toIsoString(value);
  if (!iso) return <span className={className}>{fallback}</span>;
  return (
    <time className={className} dateTime={iso} title={formatDateTime(value, '-', timeZone)}>
      {formatRelative(value, new Date(), fallback)}
    </time>
  );
};

export default RelativeTime;
